import SmallCard from '@/components/SmallCard';

import type { MyCyberScorecardDTO } from '../../Dashboard.types';
import { handleCyberScoreCardColors } from '../../Dashboard.utils';
import useStyles from '../DashboardMCSC.styles';

const MCSCSmallCards = ({
  selectedMCSCAssessment
}: {
  selectedMCSCAssessment: MyCyberScorecardDTO;
}) => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="MyCyberScore"
          primaryContent={
            selectedMCSCAssessment?.my_cyber_score?.total.toFixed(1) ?? 0
          } // Fallback to 0 if total is undefined
          secondaryContent={`/ ${selectedMCSCAssessment?.my_cyber_score?.target.toFixed(
            1
          )}`}
          color={handleCyberScoreCardColors(
            (selectedMCSCAssessment?.my_cyber_score?.total ?? 0) /
              (selectedMCSCAssessment?.my_cyber_score?.target ?? 1)
          )}
        />
      </div>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="MyCyberRisk"
          primaryContent={
            selectedMCSCAssessment?.my_cyber_risk?.total.toFixed(1) ?? 0
          } // Fallback to 0 if total is undefined
          secondaryContent={`/ ${selectedMCSCAssessment?.my_cyber_risk?.target.toFixed(
            1
          )}`}
          color={handleCyberScoreCardColors(
            (selectedMCSCAssessment?.my_cyber_risk?.total ?? 0) /
              (selectedMCSCAssessment?.my_cyber_risk?.target ?? 1)
          )}
        />
      </div>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="Controls Completed"
          primaryContent={selectedMCSCAssessment?.controls_completed}
          secondaryContent={`/ ${selectedMCSCAssessment?.controls_total}`}
        />
      </div>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="MyCyberScore Progress"
          primaryContent={`${selectedMCSCAssessment?.my_cyber_score?.progress.toFixed(
            1
          )}%`}
        />
      </div>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="MyCyberRisk Progress"
          primaryContent={`${selectedMCSCAssessment?.my_cyber_risk?.progress.toFixed(
            1
          )}%`}
        />
      </div>
      <div className={classes.dashboardSmallItem}>
        <SmallCard
          title="Risk Impact"
          primaryContent={selectedMCSCAssessment?.risk_impact.toFixed(1)}
        />
      </div>
    </>
  );
};

MCSCSmallCards.displayName = 'MCSCSmallCards';

export default MCSCSmallCards;
